import dayjs from "dayjs";

export const getUtcOffset = (zone: string): string => {
  try {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: zone,
      timeZoneName: "short",
    });
    const parts = formatter.formatToParts(now);

    const offsetPart =
      parts.find((part) => part.type === "timeZoneName")?.value || "";
    if (/GMT[+-]\d+/.test(offsetPart)) {
      const match = offsetPart.match(/GMT([+-]\d+)/);
      return match ? `UTC${match[1]}:00` : "UTC+0:00";
    }
    return "UTC+0:00";
  } catch (error) {
    console.error(`Error calculating UTC offset for ${zone}:`, error);
    return "UTC+0:00";
  }
};

export const formatToApiDateTime = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}${month}${day}${hours}${minutes}${seconds}`;
};

export const today = new Date();
export const lastWeek = new Date(today);
lastWeek.setDate(today.getDate() - 7);

export const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDateTime = (date: Date) => {
  const pad = (n: number) => String(n).padStart(2, "0");
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hour = pad(date.getHours());
  const minute = pad(date.getMinutes());
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

export const convertToTrendFormat = (dateStr: string): string => {
  return dayjs(dateStr).format("YYYYMMDDHHmmss");
};
